import { Actions } from 'vuex-smart-module';
import { ReportsService } from '@/modules/reports/services';
import { Reports } from '@/modules/reports/types';
import ReportsSalesGetters from './getters';
import ReportsSalesMutations from './mutations';
import ReportsSalesState from './state';

const reportsService = new ReportsService();

export default class ReportsSalesActions extends Actions<
  ReportsSalesState,
  ReportsSalesGetters,
  ReportsSalesMutations,
  ReportsSalesActions
> {
  async get_sales_reports() {
    try {
      const {
        sortBy = [], sortDesc = [], page = 1, itemsPerPage = 10,
      } = this.state.table_options;

      const filtersEmpty = Boolean(this.state.years.length);

      const payload: Reports.PlanFactRequest = {
        filters: this.state.filters,
        filters_exist: filtersEmpty,
        pagination: {
          limit: itemsPerPage,
          page,
          sort: '',
          sort_type: 'asc',
        },
      };

      if (sortBy?.length) {
        [payload.pagination.sort] = sortBy;
      }

      if (sortDesc?.length) {
        payload.pagination.sort_type = sortDesc[0] ? 'desc' : 'asc';
      }

      this.mutations.TOGGLE_LOADING(true);

      const { data, meta } = await reportsService.get_sales_reports(payload);

      if (!filtersEmpty) {
        this.mutations.SET_YEARS(data.filters.years);
      }

      this.mutations.SET_SALES(data.items);
      this.mutations.SET_TOTAL_PERCENT(data.total_percent);
      this.mutations.UPD_TABLE_OPTIONS({ key: 'itemsPerPage', value: meta.limit });
      this.mutations.UPD_TABLE_OPTIONS({ key: 'page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'current_page', value: meta.current_page });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_pages', value: meta.total_pages });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'total_items', value: meta.total_items });
      this.mutations.UPD_PAGINATION_FIELD({ key: 'limit', value: meta.limit });
      return true;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      this.mutations.TOGGLE_LOADING(false);
    }
  }
}
